/* jshint esversion: 6 */
import React from 'react';
import Modal from 'app/components/common/Modal.jsx';
import UserMessages from 'app/modules/UserMessageModule.js';
import makeToast from 'app/modules/makeToast.js';

class PostAnalysisModal extends React.Component {
    constructor(props) {
        super(props);

        this.dismissModal = this.dismissModal.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);

    }

    componentDidMount() {
        document.addEventListener('keyup', this.onKeyUp);
    }

    componentWillUnmount() {
        document.removeEventListener('keyup', this.onKeyUp);
    }

    onKeyUp(e) {

        if (e.key === "Escape") {
            this.dismissModal();
        }

    }

    dismissModal(e) {

        if (this.props.recordEvent) {
            this.props.recordEvent({
                pub_id: this.props.user.detail.id,
                event_name: 'Post Analysis Interest - No',
            });
        }

        this.props.dismissModal();

    }

    render() {
        let modalContent = null,
            imageUrl = this.props.app.config.assetsUrl + "/" + this.props.app.config.imageUrl;

        modalContent = (
            <div className="trial-end-warning">
                <div className="close-warning" onClick={this.dismissModal} aria-label='close' role="button">
                    <i className="fa fa-times"></i>
                </div>
                <div className="big-icon">
                    <img src={`${imageUrl}/misc/flame-star-icon.svg`} width="175" height="auto"/>
                </div>
                <div className="teaser-content">
                    <h3 style={{"fontWeight": 500}}>Post Analyzer &ndash; coming soon</h3>
                    <p>Identify your top posts, then remix and reshare them to boost engagement.</p>
                </div>
                <div className="register-interest" onClick={(e) => {
                    if (this.props.recordEvent) {
                        this.props.recordEvent({
                            pub_id: this.props.user.detail.id,
                            event_name: 'Post Analysis Interest - Yes',
                        });
                    }
                    makeToast("We'll notify you when this is available.", "success");
                    this.props.dismissModal(e);

                }} role="button auto-width" aria-label="subscribe">
                    Get details
                </div>
            </div>
        )

        return (
            <Modal
                content={modalContent}
                boxClass={"trial-end-box"}
                mainClass={"trial-end-content"} />
        );
    }
}

PostAnalysisModal.displayName = "PostAnalysisModal";

export default PostAnalysisModal;
